<template>

    <div class="login-wrap">
        <div class="title">
            <span class="text-linear-gradieant">城投能源智能出行SAAS平台</span>
        </div>
        <div class="container">
            <div class="ms-login-box">
                <div class="ms-login">
                    <div class="ms-title">用户登录</div>
                    <el-form :model="param" :rules="rules" ref="login" label-width="0px" class="ms-content">
                        <el-form-item prop="username">
                            <el-input v-model="param.username" placeholder="用户名">
                            </el-input>
                        </el-form-item>
                        <el-form-item prop="password">
                            <el-input type="password" placeholder="密码" v-model="param.password" @keyup.enter.native="submitForm()">
                            </el-input>
                        </el-form-item>
                        <el-form-item prop="vcode">
                            <el-input  placeholder="验证码" v-model="param.vcode" >
                                <template slot="append">
                                    <img v-if="loading" style="width: 16px;height: 16px" src="../../assets/img/indicator.gif">
                                    <img v-else style="width: 60px;height: 26px" :src="vcode" @click="initVcode">
                                </template>
                            </el-input>
                        </el-form-item>
                        <div class="login-btn">
                            <el-button type="primary" @click="submitForm()">登录</el-button>
                        </div>
                    </el-form>
                </div>
            </div>
        </div>


    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                param: {
                    username: '',
                    password: '',
                    vcode:''
                },
                vcode:'',
                requestId:'',
                loading:false,
                rules: {
                    username: [{
                        required: true,
                        message: '请输入用户名',
                        trigger: 'blur'
                    }],
                    password: [{
                        required: true,
                        message: '请输入密码',
                        trigger: 'blur'
                    }],
                    vcode: [{
                        required: true,
                        message: '请输入验证码',
                        trigger: 'blur'
                    }]
                },
                menu: [],
                backgrond: '',
                targetUrl:''
            };
        },
        created() {
            // let targetUrl = this.$route.query.targetUrl;
            // if(targetUrl){
            //     this.targetUrl = targetUrl;
            // }
            // let key = localStorage.getItem("sso-key");
            // if (key){
            //     this.HTTP.get("/sso/login/check?key="+key).then(res=>{
            //         if (res.data.success){
            //             if (this.targetUrl){
            //                 window.location.href =this.targetUrl+"?key="+key;
            //             }else{
            //                 this.$router.push("/main");
            //             }
            //         }else{
            //             localStorage.removeItem("sso-key")
            //         }
            //     });
            // }
            this.init()
        },
        methods: {
            init(){
                this.initVcode();
            },
            initVcode(){
                this.loading = true
                this.HTTP.get('/sso/login/getVCodeImage').then(res=> {
                    if (res.data.success) {
                        this.vcode = "data:image/png;base64,"+res.data.data.vcodeImage
                        this.requestId = res.data.data.id
                    }else{
                        this.$message.error('获取验证码失败');
                    }
                    this.loading = false
                })
            },
            submitForm() {
                this.$refs.login.validate(valid => {
                    if (valid) {
                        let userInfo = {
                            userName:this.param.username,
                            userPwd:this.param.password,
                            targetUrl:this.targetUrl,
                            vcode:this.param.vcode
                        }
                        this.HTTP.post('/sso/login', userInfo,{
                            headers: {
                                'REQUESTID': this.requestId
                            }
                        }).then(res => {
                            if (res.data.code == 1) {
                                localStorage.setItem("sso-key",res.data.data);
                                if(this.targetUrl){
                                    debugger
                                    window.location.href = this.targetUrl+"?key="+res.data.data;
                                }else{
                                    this.$router.push("/main");
                                }
                            } else {
                                this.$message.error(res.data.message);
                            }
                        }).catch(err => {
                            console.log(err)
                        })
                    } else {
                        this.$message.error('请输入账号和密码');
                        return false;
                    }
                });
            }
        },
    };
</script>
<style>
    .el-input-group__append{
        padding: 0 5px;
    }
</style>
<style scoped>

    @font-face {
        font-family: hylxtj1;
        src: url('../../assets/css/HYk2gj.svg#HYk2gj') format('svg'),
        url('../../assets/css/HYk2gj.ttf') format('truetype'),
        url('../../assets/css/HYk2gj.woff') format('woff'),
        url('../../assets/css/hylxtj.woff2') format('woff2'),
        url('../../assets/css/hylxtj.eot'),
        url('../../assets/css/hylxtj.eot?#iefix') format('embedded-opentype')
    }
    .title{
        box-sizing: border-box;
        text-align: center;
        width: 100%;
        height: 3.8rem;
        background: url("../../assets/img/title-back.png") no-repeat center;
        background-size: 100% 100%;
        text-align: center;
    }
    .title span{
        line-height: 3.8rem;
        letter-spacing: 0.3rem;
        font-family: hylxtj1;
        font-size: 1.9rem;
    }
    .text-linear-gradieant{
        background: linear-gradient(to bottom, #BCDFE1, #8AC5FF);
        -webkit-background-clip: text;
        color: transparent;
    }

    .login-wrap {
        width: 100%;
        height: 100%;
        background-color: black;
        /* background-image: url(../../assets/img/login-bg.jpg); */
        background-size: 100%;
        display: flex;
        flex-direction: column;
    }

    .ms-title{
        font-size: 1.5rem;
        text-align: center;
        line-height: 1.5rem;
        height: 1.5rem;
        color: white;
        font-weight: bold;
        box-sizing: border-box;
        letter-spacing: 0.2rem;
    }
    .container{
        width: 100%;
        flex-grow: 1;
        background-color: transparent;
        background: url("../../assets/img/newback.jpg") no-repeat center;
        background-size: 100% 100%;
        border: none;
        box-sizing: border-box;
    }
    .ms-login-box{
        box-sizing: border-box;
        margin: 0 auto;
        width: 35rem;
        height: auto;
        padding: 40px 40px;
        background: url("../../assets/img/login-box-back.png") no-repeat center;
        background-size: 100% 100%;
        margin-top: 10rem;
    }
    .ms-login {
        box-sizing: border-box;
        width: 100%;
        height: 100%;
        background: url("../../assets/img/login-back.png") no-repeat center;
        background-size: 100% 100%;
        padding: 40px 60px;
    }

    .ms-content {
        padding: 30px 30px;
    }

    .login-btn {
        text-align: center;
    }

    .login-btn button {
        width: 100%;
        height: 36px;
        margin-bottom: 10px;
    }
    .ms-content >>> .el-input input{
        background-color: #062f60;
        color: white;
    }
</style>
